import React from 'react';

import selectFiles from '@chenyuwang/select-files';
import { Button } from '@components/Button';
import { FileArrayDisplay } from '@components/utilities/BookingInquiry/FileArrayDisplay';
import { RemoteFileField } from '@utils/forms';
import { useField } from 'formik';

export interface FileUploadProps {
  name: string;
  buttonText: string;
  confirmStatus: boolean;
  buttonProps?: Partial<React.ComponentProps<typeof Button>>;
}

export const FileUpload: React.FC<FileUploadProps> = (props) => {
  const { name, buttonText, confirmStatus, buttonProps } = props;

  const [field, , helpers] = useField<RemoteFileField[] | undefined>(name);

  const value = field.value ?? [];

  return (
    <>
      <FileArrayDisplay
        files={value}
        onDelete={(index) => {
          const newFiles = [...value];
          newFiles.splice(index, 1);
          helpers.setValue(newFiles);
        }}
        readOnly={confirmStatus}
      />
      {!confirmStatus ? (
        <Button
          color="primary"
          shape="round"
          size="small"
          type="button"
          text={buttonText}
          {...buttonProps}
          onClick={async (e) => {
            buttonProps?.onClick?.(e);
            const uploadFiles = await selectFiles({
              accept:
                '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/plain,.pdf,image/*',
              multiple: true,
            });

            if (uploadFiles !== null && uploadFiles.length > 0) {
              const remoteFiles = [...uploadFiles].map((file) => ({
                file,
                remote: null,
              }));
              helpers.setValue([...value, ...remoteFiles]);
            }
          }}
        />
      ) : null}
    </>
  );
};
